import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

const styles = makeStyles((theme) => ({
  root: {
    flex: 1,
    width: '100%'
  },
  buttom: {
    padding: theme.spacing(1)
  }
}));

class TablePaginationActions extends React.Component {

  handleFirstPageButtonClick = (event) => {
    this.props.onChangePage(0);
  };

  handleBackButtonClick = (event) => {
    this.props.onChangePage(this.props.page - 1);
  };

  handleNextButtonClick = (event) => {
    this.props.onChangePage(this.props.page + 1);
  };

  handleLastPageButtonClick = (event) => {
    this.props.onChangePage(Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1));
  };

  render() {

    let { classes } = this.props;
    const { count, page, rowsPerPage } = this.props;
    return (

      <div className={classes.root}>
        <Box flexGrow={1} display="flex" p={0}>
          <Box >
            <IconButton
              onClick={this.handleFirstPageButtonClick}
              disabled={page === 0}
              aria-label="first page"
            >
              <FirstPageIcon />
            </IconButton>
          </Box>
          <Box>
            <IconButton onClick={this.handleBackButtonClick} disabled={page === 0} aria-label="previous page">
              <KeyboardArrowLeft />
            </IconButton>
          </Box>
          <Box>
            <IconButton
              onClick={this.handleNextButtonClick}
              disabled={page >= Math.ceil(count / rowsPerPage) - 1}
              aria-label="next page"
            >
              <KeyboardArrowRight />
            </IconButton>
          </Box>
          <Box>
            <IconButton
              onClick={this.handleLastPageButtonClick}
              disabled={page >= Math.ceil(count / rowsPerPage) - 1}
              aria-label="last page"
            >
              <LastPageIcon />
            </IconButton>
          </Box>
        </Box>
      </div>
    );
  }
}


export default compose(
  withStyles(styles),
  connect()
)(TablePaginationActions);